var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1599_7915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6221 32.6094C7.06155 32.6094 0.12207 25.446 0.12207 16.6094C0.12207 7.77271 7.06155 0.609375 15.6221 0.609375C24.1826 0.609375 31.1221 7.77271 31.1221 16.6094C31.1119 25.4417 24.1783 32.5989 15.6221 32.6094ZM15.6221 2.60938C8.13176 2.60938 2.05957 8.87744 2.05957 16.6094C2.05957 24.3413 8.13176 30.6094 15.6221 30.6094C23.1124 30.6094 29.1846 24.3413 29.1846 16.6094C29.1765 8.88086 23.1091 2.61768 15.6221 2.60938Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.622 18.6094C12.8175 18.4617 10.6543 16.0051 10.7783 13.1094C10.6543 10.2136 12.8175 7.75708 15.622 7.60938C18.4266 7.75708 20.5897 10.2136 20.4658 13.1094C20.5897 16.0051 18.4266 18.4617 15.622 18.6094ZM15.622 9.60938C13.8893 9.75977 12.5947 11.3188 12.7158 13.1094C12.5947 14.8999 13.8893 16.459 15.622 16.6094C17.3547 16.459 18.6494 14.8999 18.5283 13.1094C18.6494 11.3188 17.3547 9.75977 15.622 9.60938Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80957 23.6094C9.27458 23.6094 8.84082 23.1616 8.84082 22.6094C8.84082 19.3003 11.8826 16.6094 15.6221 16.6094C16.1571 16.6094 16.5908 17.0571 16.5908 17.6094C16.5908 18.1616 16.1571 18.6094 15.6221 18.6094C12.9511 18.6094 10.7783 20.4033 10.7783 22.6094C10.7783 23.1616 10.3446 23.6094 9.80957 23.6094Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5284 25.6088C18.2715 25.6088 18.0251 25.5033 17.8434 25.3158L15.9059 23.3158C15.5389 22.9235 15.5441 22.2997 15.9178 21.914C16.2915 21.5282 16.8957 21.5229 17.2758 21.9018L18.5284 23.1947L23.6559 17.9018C24.036 17.5229 24.6403 17.5282 25.014 17.914C25.3877 18.2997 25.3929 18.9235 25.0258 19.3158L19.2133 25.3158C19.0317 25.5033 18.7852 25.6088 18.5284 25.6088Z",
    fill: "#1996A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1599_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(0.12207 0.609375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAssigned);
export default __webpack_public_path__ + "static/media/TaskAssigned.a26e2c536b9e0b194affe35f1b1bc320.svg";
export { ForwardRef as ReactComponent };